import Decoration from "./Decoration";
export default Decoration;
